import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { Observable } from "rxjs/Observable";

export interface TransactionData {
  transaction_id: string;
  product_id: string;
  price_str: string;
  currency: string;
  receipt_data: string;
}

@Injectable()
export class PurchaseProvider {
  private url: string = "purchase";

  constructor(public api: Api) {}

  subscriptions(
    transactionData: TransactionData,
    isCampaign: boolean
  ): Observable<any> {
    return this.api.post(this.url + "/subscriptions", {
      transaction: transactionData,
      campaign: isCampaign
    });
  }

  restore(transactionId: string, receiptData: string): Observable<any> {
    return this.api.post(this.url + "/subscriptions/restore", {
      transaction_id: transactionId,
      receipt_data: receiptData
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/purchase/purchase.ts